export default {
  page_title: 'Promo Code Details',
  back: 'Back',
  tabs: {
    configuration: 'Configuration',
  },
  status: {
    active: 'Active',
    draft: 'Draft',
    inactive: 'Complete',
    complete: 'Complete',
    expired: 'Expired',
  },
  actions: {
    edit: 'Edit',
    end_promotion: 'End promotion',
    reactivate_promotion: 'Reactivate',
    reactivating: 'Reactivating...',
    download_csv: 'Download CSV',
    downloading_csv: 'Downloading...',
    generating_csv: 'Generating CSV...',
    generating_csv_helper:
      'Generation can take several minutes for large pools. Refresh to check progress.',
    export_csv: 'Export CSV',
    exporting_csv: 'Exporting...',
  },
  ongoing: 'Ongoing (no end date)',
  until_date: 'Until',
  configuration: {
    title: 'Configuration',
    promo_code: {
      title: 'Promo code',
      type_label: 'Promo code type',
      type_single: 'Single shared code',
      type_unique: 'Unique Codes',
      code_label: 'Code',
      count_label: 'Number of codes',
      count_generating: 'Generating…',
    },
    rewards: {
      title: 'Offers',
      prompt: 'Which offer should this promo code apply',
      // Offer summary copy. Match the offers UI labels so a merchant who
      // configured their offer there sees consistent language here.
      summary: {
        amount: '$%{value} off',
        percent: '%{value}% off',
        item: 'Free item',
        // FixedPrice variants. `free_*` scopes are price-capped at 0 by
        // the model; `base_item` and friends show the cap as a price.
        fixed_price_free: 'Free item',
        fixed_price_paid: 'Fixed price — $%{value}',
        // Defensive fallbacks. The producer (transformPromotion) sets
        // discountValue for amount/percent/fixed_price; these copy
        // strings only render if the value is unexpectedly null, or if a
        // new discountType ships from the API before this UI catches up.
        amount_unknown: 'Amount off',
        percent_unknown: 'Percent off',
        fixed_price_unknown: 'Fixed price',
        unknown: 'Custom offer',
      },
    },
    locations: {
      title: 'Participating locations',
      prompt: 'Where can this promo be used:',
      all: 'All locations (in-store and online)',
      instore: 'In-store only',
      online: 'Online only',
    },
    channels: {
      title: 'Channel availability',
      online_label: 'Works online',
      pos_label: 'Works at POS',
    },
    redemption: {
      title: 'Redemption settings',
      valid_from: 'Promo code will be valid from',
      valid_until: 'Promo code will be valid until',
      no_date: 'No date set',
      restrictions: 'Restrictions',
      max_discount: 'Customers can receive a maximum discount of $%{amount}',
      min_spend: 'Customers must spend at least $%{amount}',
    },
  },
  confirm_end: {
    title: 'End promotion',
    message:
      'Are you sure you want to end this promotion? Customers will no longer be able to redeem this code.',
    confirm: 'End promotion',
    ending: 'Ending...',
  },
  confirm_reactivate: {
    title: 'Reactivate promo code',
    message:
      'Customers will be able to redeem this code again, using the same codes you already distributed.',
    confirm: 'Reactivate',
    reactivating: 'Reactivating...',
  },
  alerts: {
    load_error: 'Could not load this promotion.',
    end_success: 'Promotion ended successfully.',
    end_error: 'Failed to end promotion.',
    reactivate_success: 'Promo code reactivated.',
    reactivate_error: 'Failed to reactivate this promo code.',
    download_error: 'Could not download the CSV. Please try again.',
    export_queued:
      'CSV export queued. We’ll post the download link here when it’s ready.',
    export_error: 'Could not queue the CSV export. Please try again.',
  },
}
